export const BUSINESS_TYPES = ["Foodservice", "Other"];
